import {Separator} from 'platform/components';
import {Box, HStack, Space, VStack} from 'platform/foundation';

// Disabled for path, because we safely return if the path is not found
// eslint-disable-next-line no-restricted-imports
import {isNil, path} from 'ramda';

import {GetWarehousesResponse} from '@dms/api/warehouse';
import {
  ArticleFolderTree,
  DmsDataGrid,
  WarehouseTabExternalFilters,
  useWarehouseDataGridTreeFolder,
} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

import type {RowData} from 'features/eag-grid';

const EXTERNAL_FILTER_ID = 'pair-warehouse-article-modal-external-filter';

const PREDEFINED_COLUMNS = ['articleId', 'warehouseId'] as const;

interface PairWarehouseArticleModalWarehouseTabProps extends TestIdProps {
  availableWarehouses: GetWarehousesResponse;
  onRowSelection: (articleId: string, warehouseId: string) => void;
}

export function PairWarehouseArticleModalWarehouseTab(
  props: PairWarehouseArticleModalWarehouseTabProps
) {
  const [folderTreeRef, dataGridModifier] = useWarehouseDataGridTreeFolder({
    availableWarehouses: props.availableWarehouses,
  });

  const handleRowSelection = (rows: RowData[]) => {
    const row = rows[0];
    const articleId = path(['articleId', 'value'], row) as string;
    const warehouseId = path(['warehouseId', 'value', 'key'], row) as string;

    if (isNil(articleId) || isNil(warehouseId)) {
      return;
    }

    props.onRowSelection(articleId, warehouseId);
  };

  return (
    <HStack height="100%" data-testid={props['data-testid']}>
      <Box flex={1}>
        <VStack height="100%">
          <Box>
            <div id={EXTERNAL_FILTER_ID} />
          </Box>
          <Space vertical={8} />
          <ArticleFolderTree
            ref={folderTreeRef}
            data-testid={suffixTestId('articleFolderTree', props)}
          />
        </VStack>
      </Box>
      <Separator orientation="vertical" />
      <Box flex={3}>
        <DmsDataGrid
          // DG must be re-rendered on folder change to update the query modifier
          // eslint-disable-next-line eslint-js/no-restricted-syntax
          key={dataGridModifier?.key}
          gridCode="selectable-materials-pair-warehouse-article"
          queryModifier={dataGridModifier?.queryModifier}
          onRowSelectionChange={handleRowSelection}
          predefinedColumns={PREDEFINED_COLUMNS}
          externalFilterId={EXTERNAL_FILTER_ID}
          filterComponent={(datagridProps) => (
            <WarehouseTabExternalFilters
              {...datagridProps}
              data-testid={suffixTestId('dg-external-filters', props)}
            />
          )}
        />
      </Box>
    </HStack>
  );
}
